module.exports = __webpack_public_path__ + "img/rider-express.97d7e324.png";